<template>
  <div class="main print-no-padding">
    <renewal-warning :isChain="isChain" :from="1" />
    <h2 class="is-print-hide title-area">
      <span class="main-title">数据看板</span>
      <div class="handler-area">
        <div class="showData" @click="showAllData">
          <span>查询</span>
        </div>
        <div class="timeSelect">
          <el-date-picker
            @change="dateChange"
            v-model="form.time"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="timestamp"
            :picker-options="pickerOptions"
            class="zy-date-picker"
          ></el-date-picker>
        </div>
      </div>
    </h2>
    <div class="list-content">
      <h1 class="data-board-title">处方趋势图</h1>
      <el-row style="padding-block: 16px" :gutter="16">
        <el-col v-if="shopRender()" :span="6">
          <label-input label="门店名称" width="100%">
            <el-select filterable remote v-model="form.storeId" :remote-method="_getStoreList">
              <el-option v-for="item in storeNameList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </label-input>
        </el-col>
        <el-col :span="6">
          <label-input label="药师姓名" width="100%">
            <el-select filterable remote v-model="form.auditorId" :remote-method="_get_prescription_auditor">
              <el-option v-for="item in pharmacistList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </label-input>
        </el-col>
        <el-col :span="6">
          <label-input
            label="药品名称"
            width="100%"
            type="autocomplete"
            v-model="form.drugName"
            :query-search="_get_used_drug_list"
            :input-attr="{ clearable: true }"
            value-key="name"
          ></label-input>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="showTendency">查看</el-button>
          <el-button type="default" @click="clearFormSearch">重置</el-button>
        </el-col>
      </el-row>
      <div class="chart">
        <chart-content :contentData="dayStatList" ref="myC"></chart-content>
        <div class="chartbt">
          <div class="total">
            <img :src="require('@/assets/img/icon_total.png')" alt="" />
            <span>该周期总量</span>
            <b>{{ total }}</b>
            <span>单</span>
            <el-tooltip
              class="chartbt_hint"
              effect="dark"
              content="当前时间范围内总的完成处方单数"
              placement="top-start"
            >
              <img class="hint_img" :src="require('@/assets/img/question_mark.png')" />
            </el-tooltip>
          </div>
          <div class="average">
            <img :src="require('@/assets/img/icon_average.png')" alt="" />
            <span>该周期日均</span>
            <b>{{ average }}</b>
            <span>单</span>
            <el-tooltip
              class="chartbt_hint"
              effect="dark"
              content="当前时间范围内总的完成处方单数/开方天数"
              placement="top-start"
            >
              <img class="hint_img" :src="require('@/assets/img/question_mark.png')" />
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="tableTop10Shop" v-if="shopRender()">
        <div class="top10title">top10药店处方情况</div>
        <el-table
          stripe
          :data="top10Data.store"
          row-key="id"
          size="medium"
          header-row-class-name="common-table-header"
          row-class-name="common-table-row"
          class="is-print-hide common-table"
          :border="true"
        >
          <el-table-column min-width="25%">
            <template slot-scope="scope">
              <div>TOP {{ scope.$index + 1 }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="storeName" label="药店名称" min-width="50%"></el-table-column>
          <el-table-column prop="finishCount" label="完成处方量" min-width="25%"></el-table-column>
        </el-table>
      </div>
      <div class="tableTop10Drug">
        <div class="top10title">top10药品处方情况</div>
        <el-table
          stripe
          row-key="id"
          :data="top10Data.drug"
          size="medium"
          header-row-class-name="common-table-header"
          row-class-name="common-table-row"
          class="is-print-hide common-table"
          :border="true"
        >
          <el-table-column min-width="25%">
            <template slot-scope="scope">
              <div>TOP {{ scope.$index + 1 }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="drugName" min-width="50%" label="药品名称"></el-table-column>
          <el-table-column prop="finishCount" label="完成处方量" min-width="25%"></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { hasPermission } from '@/util';
import Constant from '@/lib/constant';
import chartContent from '@/components/dashboard/content';
import searchInput from '@/components/global/form/searchInput';
import renewalWarning from '@/components/renewalWarning/renewalWarning.vue';
import labelInput from '@/components/global/form/labelInput.vue';
import { mapState } from 'vuex';
import dayjs from 'dayjs';
const baseRole = Constant.RoleList;
export default {
  name: 'dashboard_index',
  computed: {
    ...mapState('global', ['isChain'])
  },
  components: {
    chartContent,
    searchInput,
    renewalWarning,
    labelInput
  },
  data() {
    return {
      average: 0,
      total: 0,
      top10Data: {
        store: [],
        drug: []
      },
      dayStatList: [],
      form: {
        time: [],
        storeName: '', // 药店名称
        storeId: null, // 药店ID
        pharmacistName: '', // 药师名称
        auditorId: null, // 药师ID
        drugName: '',
        drugFullMatch: false // 药品是否模糊查询
      },
      pickerOptions: {
        disabledDate: time => {
          return this.dealDisabledDate(time);
        },
        shortcuts: [
          {
            text: '最近一周',
            onClick: picker => {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
              this.showAllData();
            }
          },
          {
            text: '最近两周',
            onClick: picker => {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
              picker.$emit('pick', [start, end]);
              this.showAllData();
            }
          },
          {
            text: '最近三周',
            onClick: picker => {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 21);
              picker.$emit('pick', [start, end]);
              this.showAllData();
            }
          },
          {
            text: '最近一个月',
            onClick: picker => {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
              this.showAllData();
            }
          },
          {
            text: '最近两个月',
            onClick: picker => {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
              picker.$emit('pick', [start, end]);
              this.showAllData();
            }
          },
          {
            text: '最近三个月',
            onClick: picker => {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
              this.showAllData();
            }
          }
        ]
      }, // 日期设置对象
      storeNameList: [],
      pharmacistList: []
    };
  },
  mounted() {
    this.dateInit();
    this.showAllData();
  },
  methods: {
    JudgeprescriptionEndTime() {
      // 后端要求获取当天数据时间戳需要+一天
      // 时间戳转年月日再转时间戳
      // return this.form.time[1] + 86400000;
      return +dayjs(dayjs(this.form.time[1] + 86400000).format('YYYY-MM-DD')).format('x');
    },
    formatStartTime() {
      // 时间戳转年月日再转时间戳
      return +dayjs(dayjs(this.form.time[0] * 1).format('YYYY-MM-DD')).format('x');
    },
    shopRender() {
      // 渲染门店名称筛选 top10药店
      let per = [baseRole.a, baseRole.c];
      return hasPermission(per);
    },
    dateChange() {
      // 时间改变回调
      // console.log(this.form);
    },
    dateInit() {
      // 初始化时间 默认七天
      const start = dayjs().subtract(6, 'days').format('x');
      console.log('start', start, dayjs().subtract(6, 'days'), dayjs().subtract(6, 'days').format('x'));
      const end = Date.now();
      this.form.time = [start, end];
    },
    dealDisabledDate(time) {
      // 90天前跟今天后都不能选
      if (
        time.getTime() > +dayjs().subtract(0, 'days').format('x') ||
        time.getTime() < +dayjs().subtract(90, 'days').format('x')
      ) {
        return true;
      }
    },

    resetSoreAboutStatus() {
      // 重置门店名称
      this.form.storeId = null;
      this.form.storeName = '';
      this.resetAuditorStatus();
    },
    resetAuditorStatus() {
      // 重置药师筛选
      this.form.pharmacistName = '';
      this.form.auditorId = null;
      this.resetDrugStatus();
    },
    resetDrugStatus() {
      // 重置药品
      this.form.drugName = '';
      this.form.drugFullMatch = false;
    },
    drugListSelect(item) {
      this.form.drugFullMatch = true;
    },
    storeListSelect(item) {
      // 选择药店
      this.form.storeId = item.id; // 用户手动选择药店标记
    },
    async _getStoreList(str, cb) {
      // 获取有权限的门店列表
      let res = null;
      this.form.storeId = null;
      let prescriptionStartTime = this.formatStartTime();
      // let prescriptionStartTime = this.form.time[0];
      let prescriptionEndTime = this.JudgeprescriptionEndTime();
      try {
        res = await Fetch.getStoreList({
          storeName: str,
          prescriptionStartTime,
          prescriptionEndTime
        });

        this.storeNameList = res.data.map(v => {
          v.value = v.name;
          return v;
        });
      } catch (error) {}

      cb(this.storeNameList);
    },
    auditorListSelect(item) {
      // 选择药师
      this.form.auditorId = item.auditorId;
    },
    async _get_prescription_auditor(str, cb) {
      // 获取药师列表
      let res = null;
      // let prescriptionStartTime = this.form.time[0];
      let prescriptionStartTime = this.formatStartTime();
      let prescriptionEndTime = this.JudgeprescriptionEndTime();
      let storeId = this.form.storeId;
      let storeName = this.form.storeName;
      this.form.auditorId = null;

      try {
        res = await Fetch.get_prescription_auditor({
          searchWords: str,
          prescriptionStartTime,
          prescriptionEndTime,
          storeId,
          storeName
        });
        this.pharmacistList = res.data.map(o => {
          return {
            id: o.auditorId,
            name: o.auditorName
          };
        });

        cb(data);
      } catch (error) {}
    },

    async _get_used_drug_list(str, cb) {
      // 获取药品名称列表
      let res = null;
      this.form.drugFullMatch = false;
      const { pharmacistName: auditorName, auditorId, storeName, storeId } = this.form;
      const searchWords = str;
      // let prescriptionStartTime = this.form.time[0];
      let prescriptionStartTime = this.formatStartTime();
      let prescriptionEndTime = this.JudgeprescriptionEndTime();

      try {
        res = await Fetch.get_used_drug_list({
          auditorName,
          auditorId,
          storeName,
          storeId,
          searchWords,
          prescriptionStartTime,
          prescriptionEndTime
        });
        const data = res.data.map(v => {
          v.value = v.name;
          return v;
        });

        cb(data);
      } catch (error) {}
    },
    async _getStat_prescription_tendency() {
      // 获取处方趋势数据
      let res = null;
      // let prescriptionStartTime = this.form.time[0];
      let prescriptionStartTime = this.formatStartTime();
      let prescriptionEndTime = this.JudgeprescriptionEndTime();
      const { storeId, auditorId, pharmacistName: auditorName, drugName, drugFullMatch } = this.form;
      const params = {
        prescriptionStartTime,
        prescriptionEndTime,
        storeId,
        auditorId,
        auditorName,
        drugName,
        drugFullMatch
      };
      try {
        res = await Fetch.stat_prescription_tendency(params);
        let { dayStatList } = res;
        const data = dayStatList.map(v => {
          return [v.key, v.value];
        });
        this.dayStatList = data;
        this.average = res.avgCount;
        this.total = res.totalCount;
      } catch (error) {}
    },
    async _stat_prescription_top() {
      // 获取top10数据
      let res = null;
      // let prescriptionStartTime = this.form.time[0];

      let prescriptionStartTime = this.formatStartTime();
      let prescriptionEndTime = this.JudgeprescriptionEndTime();
      try {
        res = await Fetch.stat_prescription_top({
          prescriptionStartTime,
          prescriptionEndTime
        });
        this.top10Data.store = res.storeStat;
        this.top10Data.drug = res.drugStat;
      } catch (error) {}
    },
    showTendency() {
      this._getStat_prescription_tendency();
    },
    showAllData() {
      this._stat_prescription_top();
      this.showTendency();
    },
    clearFormSearch() {
      this.resetSoreAboutStatus();
      this.showAllData();
    }
  }
};
</script>

<style lang="scss">
.tab-pre,
.el-breadcrumb {
  font-size: 12px;
  color: #999999;
  line-height: 40px;
}

.el-table th {
  background: #f7f7f7;
  color: #666;
}
// .el-pagination {
//   // margin-top: 22px;
//   text-align: center;
// }

.el-pagination__total,
.el-pagination__jump {
  color: #999;
}
</style>

<style lang="scss" scoped>
.control {
  width: 100%;
}

.title-area {
  overflow: hidden;
  padding-bottom: 10px;

  .main-title {
    float: left;
    line-height: 40px;
  }
  .handler-area {
    overflow: hidden;
    .timeSelect {
      float: right;
    }
    .showData {
      float: right;
      margin-left: 16px;
      background: #1e8dff;
      width: 80px;
      height: 40px;
      border-radius: 4px;
      border: 1px solid #1e8dff;
      text-align: center;
      line-height: 40px;
      cursor: pointer;
      span {
        font-size: 14px;
        color: #fff;
      }
    }
  }
}
.list-content {
  background: #ffffff;
  border: 1px solid #f2f2f2;
  box-shadow: 0 4px 12px 0 #ededed;
  border-radius: 4px;
  padding: 16px;
  min-height: 600px;
  .data-board-title {
    color: #242424;
    font-size: 18px;
    font-weight: bold;
  }
  .chartbt_hint {
    margin-bottom: 10px;
    margin-left: 10px;
  }

  .chartbt {
    display: flex;
    padding-top: 32px;
    .base {
      color: red;
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      height: 56px;
      box-shadow: 0px 4px 12px 0px rgba(237, 237, 237, 1);
      border-radius: 4px;
      border: 1px solid rgba(242, 242, 242, 1);
      img {
        display: block;
        width: 20px;
        margin-right: 15px;
      }
      span {
        display: block;
        color: #707070;
        font-size: 14px;
        font-weight: bold;
      }
      b {
        display: block;
        color: #1e8dff;
        font-size: 18px;
        padding: 0 24px;
        font-weight: bold;
      }
    }
    .total {
      @extend .base;
      margin-right: 16px;
    }
    .average {
      @extend .base;
      b {
        color: #ebb436;
      }
    }
  }
  .formBar {
    margin-top: 16px;
    &:after {
      content: '.';
      display: block;
      height: 0;
      clear: both;
      visibility: hidden;
    }
    .barItem {
      float: left;
      width: 368px;
      margin-right: 16px;
      margin-bottom: 10px;
      &:nth-last-child(1) {
        margin-right: 0;
      }
      .barItemName {
        color: #707070;
        font-size: 14px;
        margin-right: 8px;
      }
    }
    .showBtn {
      cursor: pointer;
      background: #fff;
      color: #1e8dff;
      height: 40px;
      width: 80px;
      border: 1px solid #1e8dff;
      font-size: 14px;
      line-height: 40px;
      text-align: center;
      border-radius: 4px;
      &.showBtn-bg {
        background: #1e8dff;
        color: #fff;
      }
      // &:hover {
      //   background: rgba(68, 184, 91, 0.1);
      // }
    }
  }
  .baseTable {
    padding-top: 40px;
    .top10title {
      font-size: 18px;
      color: #242424;
      font-weight: bold;
      padding-bottom: 16px;
    }
  }
  .tableTop10Shop {
    @extend .baseTable;
  }

  .tableTop10Drug {
    @extend .baseTable;
  }
}
</style>
